

import { isTrue } from '../../../../../utility/common/GlobalHSA';

/****************************************************************************************/
/*                             Business Report Headers                                  */
/****************************************************************************************/
export const TRAVEL_HEADER_INITIAL_STATE =
  [
    { label: "Date", key: "DATED", format: 'date' },
    { label: "Comments", key: "COMMENTS", format: '' },
    { label: "Withdrawal", key: "WITHDRAWAL" , format: 'money'},
    { label: "Deposit", key: "DEPOSIT", format: 'money' },
    { label: "Balance", key: "BALANCE", format: 'money' },
  ];
export const FEES_HEADER_INITIAL_STATE =
  [
    { label: "Processed On", key: "DATED", format: 'date' },
    { label: "Comments", key: "COMMENTS", format: '' },
    { label: "GST/HST", key: "TAX", format: 'money' },
    { label: "RST", key: "RST", format: 'money' },
    { label: "PREM", key: "PT", format: 'money' },
    { label: "Withdrawal", key: "WITHDRAWAL", format: 'money' },
    { label: "Deposit", key: "DEPOSIT", format: 'money' },
    { label: "Balance", key: "BALANCE", format: 'money' },
  ];

export const SERVICE_HEADER_INITIAL_STATE  = [
    { label: "Service Name", key: "CATEGORY", format: '' },
    { label: "Expense", key: "EXPENSE" , format: 'money' },
    { label: "Admin Fee", key: "ADMIN_FEE" , format: 'money' },
    { label: "GST", key: "GST", format: 'money' },
    { label: "HST", key: "HST", format: 'money' },
    { label: "PREM", key: "PT", format: 'money' },
    { label: "Total", key: "TOTAL", format: 'money' },
  ];

export const EMPLOYEE_BALANCE_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "EMPLOYEE", format: '' },
  { label: "Name", key: "EMPLOYEE_NAME" , format: '' },
  { label: "Balance", key: "BALANCE" , format: 'money' },
  { label: "Reset / Rollover", key: "PERIOD_TYPE_NAME", format: '' },
  { label: "Annual Limit", key: "LIMIT_AMOUNT", format: 'money' },
  { label: "Previous Year Balance", key: "PREV_BALANCE", format: 'onlyPositiveMoney' },
];

export const WELLNESS_EMPLOYEE_BALANCE_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "EMPLOYEE", format: '' },
  { label: "Name", key: "EMPLOYEE_NAME" , format: '' },
  { label: "Balance", key: "BALANCE" , format: 'money' },
  { label: "Annual Limit", key: "LIMIT1", format: 'money' },
];

export const SUMMARY_HEADER_INITIAL_STATE = [
    { label: "Expense Total", key: "EXPENSE", collapse: 'sum', format: 'money' },
    { label: "Admin Fee Total", key: "ADMINISTRATION_FEE", collapse: 'sum', format: 'money'  },
    { label: "GST Total", key: "GST", collapse: 'sum', format: 'money'  },
    { label: "RST Total", key: "RST", collapse: 'sum', format: 'money'  },
    { label: "HST Total", key: "HST", collapse: 'sum', format: 'money'  },
    { label: "PREM Total", key: "PT", collapse: 'sum', format: 'money'  },
    { label: "Total", key: "TOTAL", collapse: 'sum', format: 'money'  },
  ];

export const SUMMARY_COLLAPSE_HEADER_INITIAL_STATE = [
    { label: "Limit Name", key: "LIMIT", format: '' },
    { label: "Expense", key: "EXPENSE", format: 'money' },
    { label: "Admin Fee", key: "ADMINISTRATION_FEE", format: 'money' },
    { label: "GST", key: "GST", format: 'money' },
    { label: "RST", key: "RST", format: 'money' },
    { label: "HST", key: "HST", format: 'money' },
    { label: "PREM", key: "PT", format: 'money' },
    { label: "Total", key: "TOTAL", format: 'money' },
  ];

export const EMPLOYEE_HEADER_INITIAL_STATE = [
    { label: "Employee", key: "row", collapse: '', format: '' },
    { label: "Employee ID", key: "EMPLOYEE", collapse: '', format: '' },
    { label: "Paid Total", key: "TOTAL_PAID", collapse: 'sum', format: 'money'  },
    { label: "Admin Fee Total", key: "ADMINISTRATION_FEE", collapse: 'sum', format: 'money'  },
    { label: "GST Total", key: "GST", collapse: 'sum', format: 'money'  },
    { label: "RST Total", key: "RST", collapse: 'sum', format: 'money'  },
    { label: "HST Total", key: "HST", collapse: 'sum', format: 'money'  },
    { label: "PREM Total", key: "PREM_TAX", collapse: 'sum', format: 'money'  },
    { label: "Total", key: "DUE_FROM_EMPLOYER", collapse: 'sum' , format: 'money' },
  ];

export const DIVISION_HEADER_INITIAL_STATE = [
    { label: "Divison", key: "row", collapse: 'none', format: '' },
    { label: "Paid Total", key: "TOTAL_PAID", collapse: 'sum', format: 'money'  },
    { label: "Admin Fee Total", key: "ADMINISTRATION_FEE", collapse: 'sum', format: 'money'  },
    { label: "GST Total", key: "GST", collapse: 'sum', format: 'money' },
    { label: "RST Total", key: "RST", collapse: 'sum', format: 'money' },
    { label: "HST Total", key: "HST", collapse: 'sum', format: 'money' },
    { label: "PREM Total", key: "PREM_TAX", collapse: 'sum', format: 'money'  },
    { label: "Total", key: "DUE_FROM_EMPLOYER", collapse: 'sum', format: 'money'  },
  ];

export const CLAIM_COLLAPSE_HEADER_INITIAL_STATE = [
    { label: "Name", key: "NAME", format: '' },
    { label: "Employee ID", key: "EMPLOYEE", format: '' },
    { label: "Date", key: "PROCESSING_DATE", format: 'date' },
    { label: "Claim", key: "CLAIM", format: ''},
    { label: "Status", key: "STATE", format: '' },
    { label: "EEI Amount", key: "EEI_AMOUNT", format: 'money' },
    { label: "Paid", key: "TOTAL_PAID", format: 'money' },
    { label: "Admin Fee", key: "ADMINISTRATION_FEE", format: 'money' },
    { label: "GST", key: "GST", format: 'money' },
    { label: "RST", key: "RST", format: 'money' },
    { label: "HST", key: "HST", format: 'money' },
    { label: "PREM", key: "PREM_TAX", format: 'money' },
    { label: "Total", key: "DUE_FROM_EMPLOYER", format: 'money' },
  ];

export const RFF_HEADER_INITIAL_STATE = [
  { label: "Paid", key: "TOTAL_PAID", collapse: 'sum', format: 'money' },
  { label: "Admin Fee Total", key: "ADMINISTRATION_FEE", collapse: 'sum', format: 'money'  },
  { label: "GST Total", key: "GST", collapse: 'sum', format: 'money'  },
  { label: "RST Total", key: "RST", collapse: 'sum', format: 'money'  },
  { label: "HST Total", key: "HST", collapse: 'sum', format: 'money'  },
  { label: "PREM Total", key: "PREM_TAX", collapse: 'sum', format: 'money'  },
  { label: "Total", key: "DUE_FROM_EMPLOYER", collapse: 'sum', format: 'money'  },
];

export const RFF_COLLAPSE_HEADER_INITIAL_STATE = [
    { label: "Claim", key: "CLAIM", format: ''},
    { label: "Division/Employee", key: "DIVISION", format: '' },
    { label: "Employee", key: "EMPLOYEE", format: '' },
    { label: "Paid", key: "TOTAL_PAID", format: 'money' },
    { label: "Admin Fee", key: "ADMINISTRATION_FEE", format: 'money' },
    { label: "GST", key: "GST", format: 'money' },
    { label: "RST", key: "RST", format: 'money' },
    { label: "HST", key: "HST", format: 'money' },
    { label: "PREM", key: "PREM_TAX", format: 'money' },
    { label: "Total", key: "DUE_FROM_EMPLOYER", format: 'money' },
  ];

export const EEI_HEADER_INITIAL_STATE = [
  { label: "Dated", key: "DATED", format: 'date'},
  { label: "Comments", key: "COMMENTS", format: ''},
  { label: "Withdraw", key: "WITHDRAWAL", format: 'money'},
  { label: "Deposit", key: "DEPOSIT", format: 'money'},
  { label: "Balance", key: "BALANCE", format: 'money'},
];

export const EEI_ACTIVITY_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", collapse: '', format: ''},
  { label: "Employee ID", key: "EMPLOYEE", collapse: '', format: ''},
  { label: "Total EEI AMOUNT", key: "EEI_AMOUNT", collapse: 'sum', format: 'money'},
  { label: "Total RST", key: "RST_AMOUNT", collapse: 'sum', format: 'money'},
];

export const EEI_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", format: ''},
  { label: "Employee ID", key: "EMPLOYEE", format: ''},
  { label: "EEI Effective", key: "EEI_EFFECTIVE_DATE", format: 'date' },
  { label: "EEI Termination", key: "EEI_TERMINATION_DATE", format: 'date'},
  { label: "EEI Amount", key: "EEI_AMOUNT", format: 'money'},
  { label: "RST", key: "RST_AMOUNT", format: 'money'},
  ];

export const TRAVEL_ACTIVITY_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", collapse: '', format: ''},
  { label: "Employee ID", key: "EMPLOYEE", collapse: '', format: ''},
  { label: "Total TI AMOUNT", key: "TI_AMOUNT", collapse: 'sum', format: 'money'},
  { label: "Total RST", key: "RST_AMOUNT", collapse: 'sum', format: 'money'},
];

export const TRAVEL_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", format: ''},
  { label: "Employee ID", key: "EMPLOYEE", format: ''},
  { label: "TI Effective", key: "TRAVEL_INS_EFFECTIVE_DATE", format: 'date' },
  { label: "TI Termination", key: "TRAVEL_INS_TERMINATION_DATE", format: 'date'},
  { label: "TI Waived", key: "TRAVEL_INS_WAIVED", format: 'booleanStatus' },
  { label: "Use Spousal TI", key: "USE_SPOUSAL_TRAVEL_INS", format: 'booleanStatus'},
  { label: "TI Amount", key: "TI_AMOUNT", format: 'money'},
  { label: "RST", key: "RST_AMOUNT", format: 'money'},
  ];

export const CAT_HEADER_INITIAL_STATE = [
  { label: "Dated", key: "DATED", format: 'date'},
  { label: "Comments", key: "COMMENTS", format: ''},
  { label: "Withdraw", key: "WITHDRAWAL", format: 'money'},
  { label: "Deposit", key: "DEPOSIT", format: 'money'},
  { label: "Balance", key: "BALANCE", format: 'money'},
];

export const CAT_ACTIVITY_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", collapse: '', format: ''},
  { label: "Employee ID", key: "EMPLOYEE", collapse: '', format: ''},
  { label: "Total TI AMOUNT", key: "EMPLOYER_COST", collapse: 'sum', format: 'money'},
  { label: "Total RST", key: "RST_AMOUNT", collapse: 'sum', format: 'money'},
];

export const CAT_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE = [
  { label: "Employee", key: "NAME", format: ''},
  { label: "Employee ID", key: "EMPLOYEE", format: ''},
  { label: "TI Effective", key: "START_DATE", format: 'date' },
  { label: "TI Termination", key: "TERMINATION_DATE", format: 'date'},
  { label: "Waived", key: "INS_WAIVED", format: 'booleanStatus' },
  { label: "Use Spousal Coverage", key: "USE_SPOUSAL_COVERAGE", format: 'booleanStatus'},
  { label: "Amount", key: "EMPLOYER_COST", format: 'money'},
  { label: "RST", key: "RST_AMOUNT", format: 'money'},
  ];

export const INSURANCE_COVERAGE_HEADER_INITIAL_STATE = [
  { label: "Employee Name", key: "row", collapse: 'none', format: '' },
  { label: "Employee ID", key: "EMPLOYEE", collapse: '', format: '' },
];

export const INSURANCE_COVERAGE_COLLAPSE_HEADER_INITIAL_STATE = [
  { label: "Employee Name", key: "NAME", format: '' },
  { label: "Employee ID", key: "EMPLOYEE", format: '' },
  { label: "Current Age", key: "CURRENT_AGE", format: '' },
  { label: "Type", key: "COVERAGE_TYPE", format: '' },
  { label: "Travel Medical", key: "TRAVEL_MEDICAL", format: '' },
  { label: "Exceptional Expense", key: "EXCEPTIONAL_EXPENSE", format: '' },
  { label: "Catastrophic Drug", key: "CATASTROPHIC_DRUG", format: '' },
];

export const ACCOUNT_BALANCE_HEADER_INITIAL_STATE = [
  { label: "Date", key: "DATED", format: 'date' },
  { label: "Comments", key: "COMMENTS", format: '' },
  { label: "Amount", key: "TOTAL_CLAIM", format: 'money', collapse: 'sum'},
  { label: "Admin Fee", key: "ADMIN_FEE" , format: 'money', collapse: 'sum'},
  { label: "Tax", key: "TAX", format: 'money', collapse: 'sum' },
  { label: "RST", key: "RST", format: 'money', collapse: 'sum' },
  { label: "PT", key: "PT", format: 'money', collapse: 'sum' },
  { label: "Total Withdrawal", key: "WITHDRAWAL", format: 'money', collapse: 'sum'},
  { label: "Deposit", key: "DEPOSIT", format: 'money', collapse: 'sum'},
  { label: "Balance", key: "BALANCE", format: 'money' },
];

/****************************************************************************************/
/*                             Business Report Functions                                */
/****************************************************************************************/

const checkCompanyHasDivisions = (company) =>{
  const nonDivisionPlans = [1011,1012,1021,1022,1031,1032,1051,1061,1081,2000];
  const isDivisionPlan = !nonDivisionPlans.includes(parseInt(company.PLAN_CODE));
  return isDivisionPlan;
}

const checkCompanyHasWellness = (company) => {
  return company.HAS_WELLNESS === 'Y';
}

const checkCompanyHadTravel = (company) => {
  return isTrue(Number(company.HADTRV));
}

const checkCompanyHadEEI = (company) => {
  return isTrue(Number(company.HADEEI));
}

const checkCompanyHADCD = (company) => {
  return isTrue(Number(company.HADCD));
}

const checkNotInCostInsurance = (company) => {
  return ![1011,1012,1021,1022,1031,1032,1061,1081,2000].includes(parseInt(company.PLAN_CODE));
}

const checkNotInCostInsuranceCompanyHadTravel = (company) => {
  return checkNotInCostInsurance(company) && checkCompanyHadTravel(company);
}

const checkNotInCostInsuranceFamilyCompanyHadEEI = (company) => {
  return checkNotInCostInsurance(company) && checkCompanyHadEEI(company);
}

const checkNotInCostInsuranceCompanyHADCD = (company) => {
  return checkNotInCostInsurance(company) && checkCompanyHADCD(company);
}

const checkCompanyHadInsurance = (company) => {
  return company.HAD_INSURANCE;
}

const checkCompanyHadWellness = (company) => {
  return company.HAD_WELLNESS;
}

const checkShowEmployeeBalances = (company) => {
  return !isTrue(company.CUSTOMIZED_BENEFITS);
}

const checkShowEmployeeWellnessBalances = (company) => {
  return !isTrue(company.CUSTOMIZED_BENEFITS) && !checkCompanyHasWellness(company);
}

/****************************************************************************************/
/*                             Business Report List                                     */
/****************************************************************************************/

export const businessReportList = {
  "initial": {
    rowHeaders: {},
    reportTitle: "No report selected",
  },
  "employees": {
    rowHeaders: EMPLOYEE_HEADER_INITIAL_STATE,
    reportTitle: "Employee HSA Claim Activity ",
    collapseHeaders: CLAIM_COLLAPSE_HEADER_INITIAL_STATE,
    type: 'collapse',
    showSummary: true
  },
  "wellnessEmployee": {
    rowHeaders: EMPLOYEE_HEADER_INITIAL_STATE,
    collapseHeaders: CLAIM_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Employee Wellness Claim Activity",
    type: 'collapse',
    condition: checkCompanyHadWellness,
    showSummary: true
  },
  "divisions": {
    rowHeaders: DIVISION_HEADER_INITIAL_STATE,
    reportTitle: "HSA Claim Activity by Division",
    collapseHeaders: CLAIM_COLLAPSE_HEADER_INITIAL_STATE,
    type: 'collapse',
    showSummary: true,
    condition: checkCompanyHasDivisions,
  },
  "wellnessDivision": {
    rowHeaders: DIVISION_HEADER_INITIAL_STATE,
    reportTitle: "Wellness Claim Activity by Division",
    collapseHeaders: CLAIM_COLLAPSE_HEADER_INITIAL_STATE,
    type: 'collapse',
    condition: checkCompanyHadWellness,
    showSummary: true
  },
  "employeeBalance":{
    rowHeaders: EMPLOYEE_BALANCE_HEADER_INITIAL_STATE,
    reportTitle: "Employee Balances",
    hideDateRange: true,
    condition: checkShowEmployeeBalances,
    showSingleDate: true,
    singleDateInputProps: {
      InputProps: { minDate: "2000-01-01"}
    }
  },
  "wellnessEmployeeBalance":{
      rowHeaders: WELLNESS_EMPLOYEE_BALANCE_HEADER_INITIAL_STATE,
      reportTitle: "Wellness Employee Balances",
      condition: checkShowEmployeeWellnessBalances,
      hideDateRange: true,
      showSingleDate: true,
      singleDateInputProps:{
        InputProps: { minDate: "2000-01-01"}
      }
  },
  "serviceSummary":{
    rowHeaders: SERVICE_HEADER_INITIAL_STATE,
    reportTitle: "Expenses by Service",
  },
  "claimSummary": {
    rowHeaders: SUMMARY_HEADER_INITIAL_STATE,
    reportTitle: "Group Claim Summary",
    collapseHeaders: SUMMARY_COLLAPSE_HEADER_INITIAL_STATE,
    type: 'collapse',
    showSummary: true
  },
  "fees": {
    rowHeaders: FEES_HEADER_INITIAL_STATE,
    reportTitle: "Fees Report",
    showEmployer: true
  },
  "rff": {
    rowHeaders: RFF_HEADER_INITIAL_STATE,
    collapseHeaders: RFF_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Request For Funding Report",
    type: 'collapse',
    showSummary: true,
    hideDateRange: true
  },
  "travelStatement": {
    rowHeaders: TRAVEL_HEADER_INITIAL_STATE,
    reportTitle: "Travel Report",
    condition: checkNotInCostInsuranceCompanyHadTravel,
  },
  "travelActivity": {
    rowHeaders: TRAVEL_ACTIVITY_HEADER_INITIAL_STATE,
    collapseHeaders: TRAVEL_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Travel History Report",
    type: 'collapse',
    condition: checkCompanyHadTravel,
    showSummary: true,
    hideDateRange: true,
    showSingleDate: true
  },
  "eeiStatement": {
    rowHeaders: EEI_HEADER_INITIAL_STATE,
    reportTitle: "Exceptional Expense Insurance Statement",
    condition: checkNotInCostInsuranceFamilyCompanyHadEEI,
  },
  "eeiActivity": {
    rowHeaders: EEI_ACTIVITY_HEADER_INITIAL_STATE,
    collapseHeaders: EEI_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Exceptional Expense Insurance Activity",
    type: 'collapse',
    condition: checkCompanyHadEEI,
    showSummary: true,
    hideDateRange: true,
    showSingleDate: true
  },
  "catStatement": {
    rowHeaders: CAT_HEADER_INITIAL_STATE,
    reportTitle: "Catastrophic Drug Insurance Report",
    condition: checkNotInCostInsuranceCompanyHADCD,
  },
  "catActivity": {
    rowHeaders: CAT_ACTIVITY_HEADER_INITIAL_STATE,
    collapseHeaders: CAT_ACTIVITY_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Catastrophic Drug Insurance Activity",
    type: 'collapse',
    condition: checkCompanyHADCD,
    showSummary: true,
    hideDateRange: true,
    showSingleDate: true
  },
  "insuranceCoverage": {
    rowHeaders: INSURANCE_COVERAGE_HEADER_INITIAL_STATE,
    collapseHeaders: INSURANCE_COVERAGE_COLLAPSE_HEADER_INITIAL_STATE,
    reportTitle: "Insurance Coverage Activity",
    type: 'collapse',
    condition: checkCompanyHadInsurance,
    hideDateRange: true,
  },
  "accountBalance": {
    rowHeaders: ACCOUNT_BALANCE_HEADER_INITIAL_STATE,
    reportTitle: "Funding Account Statement",
    summaryTitle: "TOTALS FOR PERIOD",
    showSummary: true,
    showEmployer: true
  }
};
